"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApLoaderText = void 0;
var React = require("react");
var types_1 = require("../../utils/types");
var styles_1 = require("./styles");
exports.ApLoaderText = function (_a) {
    var className = _a.className, frames = _a.frames, theme = _a.theme, pauseDuration = _a.pauseDuration;
    var loaderframes = frames &&
        frames.map(function (msg, index) {
            return (React.createElement(styles_1.StyledLoaderText, { key: index, pauseDuration: pauseDuration, index: index, theme: theme }, msg));
        });
    return (React.createElement(styles_1.StyledLoaderTextWrapper, { className: "ap-loader-text " + (className ? className : '') }, loaderframes));
};
exports.ApLoaderText.defaultProps = {
    frames: [
        'Loading...',
        'Still loading...',
        'This is taking longer than expected, please wait...'
    ],
    pauseDuration: 5,
    theme: types_1.LIGHT
};
//# sourceMappingURL=ApLoaderText.js.map